window.addEventListener('pageshow', function(event) {
  // Isolate Chrome instantly so its native miracle is untouched
  const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
  if (isChrome) return; 

  // If Safari pulls the page out of its deep-freeze cache, force the refresh
  if (event.persisted) {
    console.log("Safari back cache detected! Forcing translation reload...");
    window.location.reload();
  }
});

window.addEventListener('pagehide', function(event) {
  const isChrome = /Chrome/.test(navigator.userAgent) && /Google Inc/.test(navigator.vendor);
  if (isChrome) return; // Leave Chrome's native miracle completely alone

  // If Safari is actively attempting to freeze this page into bfcache
  if (event.persisted) {
    console.log("Disrupting Safari memory cache storage...");
    
    // Drop a live timestamp into storage. This memory mutation 
    // often flags the page as 'dirty' to Safari's rendering engine.
    sessionStorage.setItem('safari_bfcache_bypass', Date.now());
  }
});

function roundEuro (selector) {
    jQuery(selector).each(function() {
        if(jQuery(this).attr("doubly-currency") == "EUR"){
          var lastDigits = 0;
          var priceFloat = 0;
          var priceStr 	 = jQuery(this).html();
          
          priceStr 		= priceStr.substring(priceStr.lastIndexOf("€") + 1,priceStr.lastIndexOf(" "));          
          lastDigits 	= priceStr.substring(priceStr.lastIndexOf(".")-1, priceStr.length);
          var lastone = +lastDigits.toString().split('').pop();
          priceFloat 	= parseFloat(priceStr);
          //console.log(priceStr);
          if((lastone == 0 || lastone == 5) && !priceStr.includes('.')) {
            return;
          }
          if(lastDigits < 2.50 && lastDigits != 0 ){
            priceFloat = priceFloat - lastDigits;
          }else if(lastDigits > 2.50 && lastDigits < 7.50){
            priceFloat = priceFloat + (5 - lastDigits );
          }else{
            priceFloat = priceFloat + (10 - lastDigits );
          }
          jQuery(this).html('€'+priceFloat.toString()+' EUR');
        }
        
    });
}

function sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms));
}

function resetSearchBoxStyles(searchBar, searchBoxInputField) {
    searchBoxInputField.style.removeProperty("min-height");
    searchBoxInputField.style.removeProperty("height");
    searchBoxInputField.style.removeProperty("margin");
    searchBoxInputField.style.removeProperty("border-bottom");
    searchBoxInputField.style.removeProperty("background-size");
    searchBar.style.removeProperty("width");
}

function transformSearchBar(){
  let searchBar = document.querySelector(".container .top_bar_search");
  let headerIcons = document.querySelector(".header__icons ul");
  let searchBoxInputField = searchBar.querySelector(".search_box");
  if(window.screen.width < 769){
    if(searchBar && headerIcons){
      searchBar.style.setProperty("width", "6%", "important"); 
      searchBoxInputField.style.setProperty("min-height", "15px", "important");
      searchBoxInputField.style.setProperty("height", "15px", "important");
      searchBoxInputField.style.setProperty("margin", "0px", "important");
      searchBoxInputField.style.setProperty("border-bottom", "none", "important");
      searchBoxInputField.style.setProperty("background-size", "18px 18px", "important");
      headerIcons.appendChild(searchBar);
    }
  }
  else{
    const originalSearchBarContainer = document.querySelector(".top_bar .container");
    resetSearchBoxStyles(searchBar, searchBoxInputField);
    originalSearchBarContainer.prepend(searchBar);
  }
}

function transformHeader(){
  let headerBar = document.querySelector(".header__icons");
  let topBar = document.querySelector(".top_bar .container");
  if(window.screen.width < 769 && headerBar){
    document.body.appendChild(headerBar);
  }
  else if(window.screen.width >= 769 && headerBar && topBar){
    topBar.appendChild(headerBar);
  }
    
}

function preventZoom(event) {
    if (event.touches && event.touches.length > 1 && !window.location.href.includes("/products/")) {
        event.preventDefault();
    }
}

async function loadPrice(selector) {
  i=0;
  while(i < 300){
    roundEuro(selector);
    await sleep(1);
    i++;
  }
}

function createRedirectButton(modalHtml) {
  const userAgent = navigator.userAgent || navigator.vendor || window.opera;
  let appLink = "";
  let appText = "";
  if (/android/i.test(userAgent)) {
    // Redirect to Google Play Store 
    appLink = "https://play.google.com/store/apps/details?id=com.ajka.crystal";
    appText = "Playstore";
  } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    // Redirect to iOS App Store
    appLink = "https://apps.apple.com/app/id6742821294";
    appText = "Appstore";
  }

  if(appLink != "" && appText != ""){
    let appButtonHtml = `<div class="option" id="app-modal-redirect" data-redirect-link="` + appLink + `">` + appText + `</div>`;
    return modalHtml.replace("[[app_advertise_placeholder]]", appButtonHtml);
  }
  else{
    return false;
  }
}

function isInAppWebView() {
  let ua = navigator.userAgent || navigator.vendor || window.opera;

  let isIOS = /iphone|ipod|ipad/i.test(ua);
  let isAndroid = /android/i.test(ua);

  let isSafari = /safari/i.test(ua);
  let isChrome = /chrome/i.test(ua);
  let isFirefox = /firefox/i.test(ua);

  // iOS WebView typically has iPhone/iPad but NOT Safari
  if (isIOS && !isSafari) return true;

  // Android WebView often has "wv" or lacks "Chrome"
  if (isAndroid && (ua.includes("wv") || !isChrome)) return true;

  return false;
}


function advertiseApps(){
    let appAdvertiseSession = sessionStorage.getItem("_app_advertise");
    
    if(!appAdvertiseSession){
      let queryString = window.location.search;
      let urlParams = new URLSearchParams(queryString);
      let appAdvertising = urlParams.has('app_advertised');
      
      if(appAdvertising){
        sessionStorage.setItem("_app_advertise", "true");
      } else {
        document.body.style.overflow = 'hidden';

        let appAdvertisingModal = `
            <div id="dispatcher-modal">
                <div class="dispatcher-wrapper">
                    <div class="dispatcher">
                        <div class="dispatcher-text">
                            <div class="dispatcher-text__title">
                                <img src="//cdn.shopify.com/s/files/1/0515/3770/7177/files/uj_logo_800x_430947ab-7e5c-4a8b-a20d-6e5083086604.png">
                            </div>
                            <div class="dispatcher-text__content">
                                <p>Try our app in the appstore or playstore!</p>
                            </div>
                            <div class="dispatcher-text__select">
                                [[app_advertise_placeholder]]
                                <div class="option" id="app-modal-continue">Continue</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        `;
        let appModalWithButton = createRedirectButton(appAdvertisingModal);

        if(appModalWithButton){
          $('body').append(appModalWithButton);

          $(document).on("click", "#app-modal-continue", function(e){
            e.preventDefault();
            sessionStorage.setItem("_app_advertise", "true");
            $("#dispatcher-modal").remove();
            document.body.style.overflow = 'auto';
          });
  
          $(document).on("click", "#app-modal-redirect", function(e){
            e.preventDefault();
            window.location.href = $(this).data("redirect-link");
          });

        }
      }
    }
  }



$(document).ready(function(){


  transformSearchBar();
  //transformHeader();
  window.addEventListener("resize", function() {
    transformSearchBar();
    //transformHeader();
  });
  console.log("removing cookie consent width");
  let cookieconsentWidthOverrideInterval = setInterval(function () {
    let el = document.querySelector('.cookieconsent-wrapper');
    if (el) {
      el.style.setProperty('width', 'unset', 'important');
      clearInterval(cookieconsentWidthOverrideInterval);
    }
  }, 100);

  
  document.addEventListener("touchstart", function (event) {    
    preventZoom(event);   
  }, { passive: false });

  
  const mobileMenuNav = document.querySelector("#mobile_nav .slicknav_nav");

  if(mobileMenuNav && window.screen.width < 800){
    mobileMenuNav.setAttribute("aria-hidden", "false");
    mobileMenuNav.style.setProperty("display", "block", "important");
  }
   $('#mobile_nav li a').each(function( index ) {
    if($( this ).text().includes("Mastercraft")){
    	$(this).attr("style", "display: none !important;");
    }
  });
  if(window.screen.width < 769){//mobileSearchBarInterval
    const mobileSearchBarInterval = setInterval(() => {
        const mobileSearchBarCustom = document.querySelector(".search_box.ui-autocomplete-input.bc-sf-search-box");
        const searchBarContainer = document.querySelector(".header__icons"); // Replace with the actual container selector
    
        if (mobileSearchBarCustom && searchBarContainer) {
            clearInterval(mobileSearchBarInterval); // Stop checking once elements are found
    
            mobileSearchBarCustom.addEventListener("focus", function () {
                mobileSearchBarCustom.removeAttribute("readonly"); // Remove readonly
                //searchBarContainer.style.visibility = "hidden";  // Hide without removing from layout
                //searchBarContainer.style.opacity = "0";  // Fade out smoothly
                //searchBarContainer.style.pointerEvents = "none"; // Prevent interactions
            });
    
            mobileSearchBarCustom.addEventListener("blur", function () {
                mobileSearchBarCustom.setAttribute("readonly", true); // Re-add readonly
                //searchBarContainer.style.visibility = "visible";  // Show it back
                //searchBarContainer.style.opacity = "1";  // Fade in smoothly
                //searchBarContainer.style.pointerEvents = "auto"; // Re-enable interactions
            });
    
            mobileSearchBarCustom.setAttribute("readonly", true); // Ensure readonly is set initially
        }
    }, 500); // Check every 500ms (adjust as needed)

  }
  
  var homePageTranslations = {
    'Stemware': {
      default: 'Stemware',
      fr: 'Verres à pied',
      de: 'Weingläser',
    },
    'Barware': {
      default: 'Barware',
      fr: 'Articles de Bar',
      de: 'Barware',
    },
    'Serving': {
      default: 'Serving',
      fr: 'Assiette de Service',
      de: 'Servierplatte',
    },
    'Home & Decoration': {
      default: 'Home & Decoration',
      fr: 'Maison & Décoration',
      de: 'Haus & Dekoration',
    },
    'Colors': {
      default: 'Colors',
      fr: 'Couleurs',
      de: 'Farben',
    },
    'Colors': {
      default: 'Colors',
      fr: 'Couleurs',
      de: 'Farben',
    },
    'Collections': {
      default: 'Collections',
      fr: 'Collections',
      de: 'Kollektionen',
    },
    'Customer favorites': {
      default: 'Customer favorites',
      fr: 'Favoris des clients',
      de: 'Kundenfavoriten',
    },
    'Replacement': {
      default: 'Replacement',
      fr: 'Remplaçant',
      de: 'Ersatz',
    },
    'New': {
       default: 'New',
       fr: 'Nouveau',
       de: 'Neu',
    }
  };
  var homePageChosenLang = window.location.href.split("/")[3];

  if (!homePageTranslations['Barware'].hasOwnProperty(homePageChosenLang)) {
    homePageChosenLang = "default";
  }
  jQuery('.featured_collections .info .info__text .title').each(function() {
      let originalTitleText = jQuery(this).text().trim();
      
      if(homePageTranslations.hasOwnProperty(originalTitleText)){
        jQuery(this).text(homePageTranslations[originalTitleText][homePageChosenLang]);
      }
  });
  jQuery('.feature-section .feature-wrap .title').each(function() {
      let originalTitleText = jQuery(this).text().trim();
      
      if(homePageTranslations.hasOwnProperty(originalTitleText)){
        jQuery(this).text(homePageTranslations[originalTitleText][homePageChosenLang]);
      }
  });
  let checkLangSelector = setInterval(() => {
    if($('.ht-tms--float').length){
      clearInterval(checkLangSelector);
      
      var headerIconsContainer = $('.header__icons ul');
      var langSelector = $('.ht-tms--float');
      langSelector.detach();
      headerIconsContainer.prepend(langSelector);
       
    }
  }, 100);
  $('.menu-navigation li a').each(function( index ) {
    if($( this ).text().includes("Replacement")){
    	//$( this ).css("font-size", "18px");
    }
    if($( this ).text().includes("Christmas")){
    	$( this ).css({
          "color": "#c61a29",
          "font-size": "18px",
        });
    }
    if($( this ).text().includes("Auction")){
    	$( this ).css({
          "color": "#c61a29",
          "font-size": "18px",
        });
    }
  });
  $('.footer_menu li a').each(function( index ) {
    
    if($( this ).text().includes("SHIPPING")){
    	$( this ).css("font-weight", "bold");
    }
  });

  $('.menu-navigation li').each(function( index ) {
    if($( this ).find('a').text().includes("Engraving")){
      //$( this ).css("display", "none");
    }
    if($( this ).find('a').text().includes("TestDropdown")){
      $( this ).css("display", "none");
    }
    if($( this ).find('a').text() == "Colors"){
      $(this).after("<br>");
    }
  });

  $('.featured_collections a').each(function(){
    if($(this).attr('title') == "Redirect to Collections page"){
      $(this).attr('href', '/pages/menu-collections');
    }
  });

  $('.shopify-section.footer-section img').each(function( index ) {
    if($( this ).attr('title') == "Paypal"){
    	$( this ).css("width", "60px");
        $( this ).css("height", "17px");
    }
    if($( this ).attr('title') == "Discover"){
    	$( this ).css("width", "50px");
        $( this ).css("height", "28px");
    }
    if($( this ).attr('title') == "Visa"){
    	$( this ).css("width", "40px");
        $( this ).css("height", "16px");
    }
    if($( this ).attr('title') == "MasterCard"){
    	$( this ).css("width", "27px");
        $( this ).css("height", "17px");
    }
    if($( this ).attr('alt') == "instagram"){
    	$( this ).css("width", "32px");
        $( this ).css("height", "32px");
    }
  });
  
  (function(){
    let countrySession = sessionStorage.getItem("_country_set");
    if(!countrySession){
      let queryString = window.location.search;
      let urlParams = new URLSearchParams(queryString);
      let locationDispatcher = urlParams.has('location_dispatcher');
      
      if(locationDispatcher){
        sessionStorage.setItem("_country_set", "true");
        if(!isInAppWebView() && window.screen.width < 550){
          advertiseApps();
        }
      } else if (window.location.href.indexOf("products") > -1 || window.location.href.indexOf("collections") > -1 || window.location.href.indexOf("pages") > -1) {        
        
      } else {
        document.body.style.overflow = 'hidden';
        /*var langSelectorTargets = ['/zh', '/ar', '/es', '/pt'];
        var langSelectorUrl = window.location.href;
        var langSelectorMatchFound = false;

        for (var i = 0; i < langSelectorTargets.length; i++) {
            if (langSelectorUrl.indexOf(langSelectorTargets[i]) !== -1) {
                langSelectorMatchFound = true;
                break;
            }
        }

        if (langSelectorMatchFound) {
            window.location.href = 'https://ajka-crystal.com/';
        }*/
       console.log("useragent here", navigator.language);

       (function () {
          const BASE_URL = 'https://ajka-crystal.com';

          const LANG_MAP = {
            'ar': 'ar',
            'pt-br': 'pt',
            'pt': 'pt',
            'de': 'de',
            'hi': 'hi',
            'ru': 'ru',
            'es': 'es',
            'zh': 'zh-hans',
            'zh-hans': 'zh-hans',
            'zh-cn': 'zh-hans',
            'zh-sg': 'zh-hans',
            'zh-hant': 'zh-hant',
            'zh-tw': 'zh-hant',
            'zh-hk': 'zh-hant',
            'zh-mo': 'zh-hant'
          };

          function resolveLanguage(tag) {
            const t = tag.toLowerCase();
            if (LANG_MAP[t]) return LANG_MAP[t];

            // Handles tags like "zh-Hans-CN" or "zh-Hant-TW"
            if (t.startsWith('zh-hans')) return 'zh-hans';
            if (t.startsWith('zh-hant')) return 'zh-hant';

            // Fall back to the primary language: "de-AT" -> "de"
            const primary = t.split('-')[0];
            return LANG_MAP[primary] || null;
          }

          const target = resolveLanguage(navigator.language || '');
          if (!target) return; // unsupported language, stay on the current page

          // Prevent redirect loops: don't redirect if already on a language version
          const currentSegment = (window.location.pathname.split('/')[1] || '').toLowerCase();
          const supported = new Set(Object.values(LANG_MAP));
          if (supported.has(currentSegment)) return;

          window.location.href = `${BASE_URL}/${target}`;
        })();
        let dispatcherModal = `
            <div id="dispatcher-modal">
                <div class="dispatcher-wrapper">
                    <div class="dispatcher">
                        <div class="dispatcher-text">
                            <div class="dispatcher-text__title">
                                <img src="//cdn.shopify.com/s/files/1/0515/3770/7177/files/uj_logo_800x_430947ab-7e5c-4a8b-a20d-6e5083086604.png">
                            </div>
                            <div class="dispatcher-text__content">
                                <p>Please select your location</p>
                            </div>
                            <div class="dispatcher-text__select">
								<div class="option" id="dispatcher-modal-stay">US & Worldwide</div>
                                <div class="option" id="dispatcher-modal-move-eu">Europe</div>
                                <div class="option" id="dispatcher-modal-move-uk">United Kingdom</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        `;

        $('body').append(dispatcherModal);

        $(document).on("click", "#dispatcher-modal-stay", function(e){
          e.preventDefault();
          sessionStorage.setItem("_country_set", "true");
          $("#dispatcher-modal").remove();
          document.body.style.overflow = 'auto';
          console.log("iframe bs", window.self, window.top);
          if(!isInAppWebView() && window.screen.width < 550){
            advertiseApps();
          }
        });

        $(document).on("click", "#dispatcher-modal-move-eu", function(e){
          e.preventDefault();
          window.location.href = "//ajka-crystal.eu/?location_dispatcher=1"
        });

        $(document).on("click", "#dispatcher-modal-move-uk", function(e){
          e.preventDefault();
          window.location.href = "//ajka-crystal.co.uk/?location_dispatcher=1"
        });
        
      }
    }
    else {
      let queryString = window.location.search;
      let urlParams = new URLSearchParams(queryString);
      let appAdvertised = urlParams.has('app_advertised');
      if(!isInAppWebView() && !appAdvertised && window.screen.width < 550){
        advertiseApps();
      }
    }
  })();
  
});

$(document).on('click', '.back-link-to-collection-page', function(e){

  if(document.referrer) {
  	//e.preventDefault();
    //history.back()
  }

});